import React from 'react';
import Fade from 'react-reveal/Fade';

import { EligibilityWrapper } from './eligibility.styled';
import Container from '../container/container.component';

interface Props {
	className?: string;
	challenge?: any;
}

const EligibilityComponent = (props: Props) => {
	const { className, challenge } = props;

	return (
		<EligibilityWrapper className={className ? className : ''}>
			<Container>
				<Fade top cascade>
					<div className="content">
						<p className="title">Who is eligible to apply?</p>
						<p
							className="description"
							dangerouslySetInnerHTML={{
								__html: challenge?.eligibilityRequirements,
							}}
						></p>
						<p className="title">Group Requirements</p>
						<p
							className="description"
							dangerouslySetInnerHTML={{ __html: challenge?.groupRequirements }}
						></p>
						<p className="title">General Requirements</p>
						<p
							className="description"
							dangerouslySetInnerHTML={{
								__html: challenge?.generalRequirements,
							}}
						></p>
					</div>
				</Fade>
			</Container>
		</EligibilityWrapper>
	);
};

export default EligibilityComponent;
